// AgeVerifierModal.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';
import AgeVerifier from '../container/AgeVerifier.js';

import { ModalId } from '../resource/mixpanel.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { getIsGoogleBot } from '../resource/getUserAgent.js';
import { unmountInitialCover } from '../resource/initialCover.js';

const isGoogleBot = getIsGoogleBot();

export const AgeVerifierModal = ({
  isAuthed = false,
  isModalDisplayed = false,
  isAgeVerifiedInValidPeriod = false,
  isRemoteConfigMerged = false,
  shouldShowLanding = false,
  shouldShowAgeVerifier = false,
  setConfirmTimestamp = NULL_FUNCTION,
  openModal = NULL_FUNCTION,
  closeModal = NULL_FUNCTION,
}) => {
  useEffect(() => {
    if (!isRemoteConfigMerged) {
      return;
    }

    const shouldShow =
      !shouldShowLanding &&
      shouldShowAgeVerifier &&
      !isAgeVerifiedInValidPeriod &&
      !isGoogleBot;

    if (shouldShow && !isModalDisplayed) {
      if (isAuthed) {
        setConfirmTimestamp();
        unmountInitialCover();
      } else {
        openModal();
      }
    } else if (!shouldShow && isModalDisplayed) {
      closeModal();
      // unmount initial cover when age verifier modal is closed
      unmountInitialCover();
    }

    // unmount initial cover when age verified is in valid period
    if (shouldShowAgeVerifier && isAgeVerifiedInValidPeriod) {
      unmountInitialCover();
    }
  }, [
    isAuthed,
    isModalDisplayed,
    isAgeVerifiedInValidPeriod,
    isRemoteConfigMerged,
    shouldShowLanding,
    shouldShowAgeVerifier,
    setConfirmTimestamp,
    closeModal,
    openModal,
  ]);

  return (
    <ModalView
      id="AgeVerifierModal"
      modalId={ModalId.Landing.ModalOver18}
      render={() => <AgeVerifier />}
    />
  );
};

AgeVerifierModal.propTypes = {
  isAuthed: PropTypes.bool,
  isModalDisplayed: PropTypes.bool,
  shouldShowLanding: PropTypes.bool,
  shouldShowAgeVerifier: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  isAgeVerifiedInValidPeriod: PropTypes.bool,
  setConfirmTimestamp: PropTypes.func,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
};

export default AgeVerifierModal;
